/* eslint-disable */

// assets
import { IconUserCircle } from '@tabler/icons';

// constant
const icons = {
    IconUserCircle
};
// Function to get title based on condition
const getTitle = (defaultTitle, bcTitle) => {
    const isBCWalletTrue = localStorage.getItem('bcWalletSuperDist'); // Check localStorage at runtime
    return isBCWalletTrue === 'true' ? defaultTitle : bcTitle;
};
const getTitleLabel2 = () => {
    const label2 = localStorage.getItem('label2');
    return label2;
};
const getTitleLabel3 = () => {
    const label3 = localStorage.getItem('label3');
    return label3;
};
// ==============================|| UTILITIES MENU ITEMS ||============================== //

const Dashboard = {
    id: 'newUtilities',
    // title: 'Super distributor',
    type: 'group',
    children: [
        // {
        //     id: 'icons1',
        //     title: 'Super Distributor',
        //     type: 'collapse',
        //     icon: icons.IconUserCircle,
        //     children: [
        {
            id: 'tabler-icons11200613940033',
            title: 'Dashboard',
            type: 'item',
            url: 'sanchalakDashboard/dashboard',
            breadcrumbs: true
        },
        {
            id: 'icons22314384344222',
            title: 'Super Distributor',
            type: 'collapse',
            children: [
                {
                    id: 'tabler-icons31284130324107009',
                    title: 'Add',
                    type: 'item',
                    url: 'sanchalakDashboard/addsuperdistributor',
                    breadcrumbs: true
                },
                {
                    id: 'tabler-icons5323048220675',
                    title: 'List',
                    type: 'item',
                    url: '/sanchalakDashboard/listsuperdistributor',
                    breadcrumbs: false
                }
               
            ]
        },
        {
            id: 'icons22384443227',
            title: 'Distributor',
            type: 'collapse',
            children: [
                {
                    id: 'tabler-icons532241188439001',
                    title: 'Add',
                    type: 'item',
                    url: '/sanchalakDashboard/adddistributor',
                    breadcrumbs: false
                },
                {
                    id: 'tabler-icons53222114844129',
                    title: 'List',
                    type: 'item',
                    url: '/sanchalakDashboard/listdistributor',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'icons2235342564',
            title: 'Merchant',
            type: 'collapse',
            children: [
                {
                    id: 'tabler-icons532241510309',
                    title: 'List',
                    type: 'item',
                    url: '/sanchalakDashboard/listmerchant',
                    breadcrumbs: false
                }
            ]
        },

        {
            id: 'tabler-icons0301335545',
            title: 'Daily Sales Monitoring',
            type: 'item',
            url: 'sanchalakDashboard/dailySalesMonitoring',
            breadcrumbs: true
        },
        {
            id: 'icons223122433252',
            title: 'Merchant Txn Track',
            type: 'collapse',
            children: [
                {
                    id: 'tabler-icons31214053112',
                    title: 'POS',
                    type: 'item',
                    url: 'sanchalakDashboard/posTxnTrack',
                    breadcrumbs: true
                },
                {
                    id: 'tabler-icons5334225111',
                    title: 'QR',
                    type: 'item',
                    url: '/sanchalakDashboard/qrTxnTrack',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'icons2231223553467',
            title: 'BC Txn Track',
            type: 'collapse',
            children: [
                {
                    id: 'tabler-icons312134401009',
                    title: 'DMT',
                    type: 'item',
                    url: 'sanchalakDashboard/dmtTxnTrack',
                    breadcrumbs: true
                },
                {
                    id: 'tabler-icons532241143008',
                    title: 'BBPS',
                    type: 'item',
                    url: '/sanchalakDashboard/bbpsTxnTrack',
                    breadcrumbs: false
                },
                {
                    id: 'tabler-icons532442131001',
                    title: 'RECHARGE',
                    type: 'item',
                    url: '/sanchalakDashboard/rechargeTxnTrack',
                    breadcrumbs: false
                },
                {
                    id: 'tabler-icons532231144002',
                    title: 'MATM',
                    type: 'item',
                    url: '/sanchalakDashboard/matmTxnTrack',
                    breadcrumbs: false
                },
                {
                    id: 'tabler-icons533422114003',
                    title: 'AEPS',
                    type: 'item',
                    url: '/sanchalakDashboard/aepsTxnTrack',
                    breadcrumbs: false
                }
            ]
        }
    ]
};

export default Dashboard;
